import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const items = [
  "Faster Payments",
  "Smarter Control",
  "Seamless Digital Growth",
  "Township Empowerment",
  "Proudly South African",
];

export const EditorialMarquee = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`relative overflow-hidden border-y py-6 ${
      dark ? "border-white/10 bg-das-ink text-white" : "border-neutral-200 bg-white text-das-ink"
    }`}
  >
    <Marquee speed={32} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-16">
          <span className="font-display text-2xl font-semibold tracking-tight sm:text-3xl">
            {item}
          </span>
          <Asterisk className="h-7 w-7 text-das-violet" strokeWidth={2.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
